<template>
    <tw-modal :show="show" @close="$emit('close')" title="Join a League">
        <jet-form-section @submitted="joinLeague">
            <template #form>
                <div class="mt-1 rounded-md shadow-sm mb-4">
                    <jet-label for="code" value="League Code" />
                    <div class="relative">
                        <jet-input :ignore-dark-mode="true" name="code" v-model="joinForm.code" placeholder="Enter a league entry code" class="mt-1 block w-full p-2" />
                        <div v-show="joinForm.errors.code" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
                        </div>
                    </div>
                </div>
                <jet-input-error :message="joinForm.errors.code" class="mt-2" />
            </template>
            <template #actions>
                <jet-button class="text-right" :ignore-dark-mode="true" :class="{ 'opacity-25': joinForm.processing }" :disabled="joinForm.processing || !joinForm.code">
                    Join League
                </jet-button>
            </template>
        </jet-form-section>
    </tw-modal>
</template>
<script>
import { ref } from 'vue'
import JetInput from '@/Jetstream/Input.vue'
import JetInputError from '@/Jetstream/InputError.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetLabel from '@/Jetstream/Label.vue'
import JetFormSection from '@/Jetstream/FormSection.vue'
import TwModal from '@/Global/Elements/TwModal.vue'
import { ExclamationCircleIcon } from '@heroicons/vue/solid'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
    emits: ['close'],

    props: {
        show: {
            type: Boolean,
            default: false,
        }
    },

    components: {
        JetInput,
        JetInputError,
        JetButton,
        JetLabel,
        JetFormSection,
        TwModal,
        ExclamationCircleIcon,
    },

    setup(props, { emit }) {

        const joinForm = useForm({
            code: null,
        })

        const joinLeague = () => {
            axios.patch(route('api.leagues.update', { code: joinForm.code }), { code: joinForm.code })
                .then(response => {
                    emit('close')
                }).catch(error =>{
                    joinForm.errors.code = error.response.data.message
                })
        }

        return {
            joinForm,
            joinLeague,
        }
    }
}

</script>
